<div class="title-bar-container" *ngIf="customerID">
    <h1 qa="requestAppt" class="main-title">Request Appointment</h1>
    <h3 qa="businessName" class="subtitle">{{ businessName }}</h3>
</div>
